import { FunctionComponent, useCallback } from 'react';

import { useCoreDispatch } from '../../../store/CoreStore';
import { useAutoplaySlice } from '../../../store/slices/autoplay/selectors';
import { useBetSlice } from '../../../store/slices/bets/selectors';
import { toastActions, ToastsProps } from '../../../store/slices/toast/slice';
import { Toast } from '../../toast/Toast';

export const AutoplayNotChangedToastConnected: FunctionComponent<ToastsProps> = ({ msg, timeStamp, ...rest }) => {
  const dispatch = useCoreDispatch();

  const savedBet = useAutoplaySlice.getSavedBet();
  const disabledBetSpots = useBetSlice.getDisabledBetSpots();

  const savedBetSpots = Object.keys(savedBet?.betSpots || {}).filter(
    (el) => (savedBet?.betSpots?.[el]?.value || 0) > 0
  );
  const someBetsUnavailable = savedBetSpots.some((r) => disabledBetSpots.includes(r));

  const closeFn = useCallback(() => {
    dispatch(toastActions.removeToast(timeStamp));
  }, [dispatch, timeStamp]);

  const message = someBetsUnavailable ? 'TOAST_SPREAD_BETS_DISABLED' : 'AUTOPLAY_CONTINUED_NO_CHANGES';

  return <Toast message={message} onClose={closeFn} {...rest} />;
};
